import React, { useState } from "react";
import FooterDrawer from "@/components/ui/atoms/FooterDrawer";
import { IconCheck } from "@tabler/icons-react";
import styles from "./MGender.module.css";

// Types
export interface MGenderProps {
  open: boolean;
  onClose: () => void;
  onDone: (gender: string) => void;
  initialValue?: string;
  title?: string;
}

const GENDER_OPTIONS = [
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
  { value: "3", label: "Prefer Not to Say" },
];

export const MGender: React.FC<MGenderProps> = ({
  open,
  onClose,
  onDone,
  initialValue,
  title = "Select Gender",
}) => {
  const [selectedGender, setSelectedGender] = useState(initialValue || "");

  const handleGenderSelect = (gender: string) => {
    setSelectedGender(gender);
    onDone(gender); // Call onDone immediately when selection is made
  };

  return (
    <FooterDrawer
      open={open}
      onClose={onClose}
      title={title}
      showClose={true}
      onDone={undefined}
      height="auto"
    >
      <div className={styles.genderWrap}>
        {GENDER_OPTIONS.map((option) => (
          <div
            key={option.value}
            className={`${styles.genderOption} ${
              selectedGender === option.value ? styles.selected : ""
            }`}
            onClick={() => handleGenderSelect(option.value)}
            role="button"
            tabIndex={0}
            aria-selected={selectedGender === option.value}
          >
            <div className={styles.genderLabel}>{option.label}</div>
            {selectedGender === option.value && (
              <IconCheck size={24} className={styles.checkmark} />
            )}
          </div>
        ))}
      </div>
    </FooterDrawer>
  );
};

export default MGender;
